import React from 'react';
import { motion } from 'framer-motion';
import './ContactSection.css';

function ContactSection({ theme = 'dante' }) {
  const isDante = theme === 'dante';
  const accentColor = isDante ? '#c41e3a' : '#1e90ff';

  return (
    <section className={`contact-section contact-${theme}`} id="contact">
      <div className="contact-container">
        <motion.div 
          className="contact-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="contact-tag">GET IN TOUCH</span>
          <h2 className="contact-title">CONTACT</h2>
          <p className="contact-subtitle">Send us a message</p>
        </motion.div>

        <motion.form 
          className="contact-form"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">NAME</label>
              <input type="text" id="name" name="name" placeholder="Your name" required />
            </div>
            <div className="form-group">
              <label htmlFor="email">EMAIL</label>
              <input type="email" id="email" name="email" placeholder="Your email" required />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="subject">SUBJECT</label>
            <input type="text" id="subject" name="subject" placeholder="Subject" required />
          </div>
          <div className="form-group">
            <label htmlFor="message">MESSAGE</label>
            <textarea id="message" name="message" rows="5" placeholder="Your message" required></textarea>
          </div>
          <motion.button 
            type="submit" 
            className="contact-submit-btn"
            whileHover={{ scale: 1.05, boxShadow: `0 0 30px ${accentColor}` }}
            whileTap={{ scale: 0.95 }}
          >
            SEND MESSAGE
          </motion.button>
        </motion.form>
      </div>
    </section>
  );
}

export default ContactSection;
